module.exports = __webpack_public_path__ + "cross-for-PDF.png?c8e4121507f8ba7b8d96beaaa9cade2c";